// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 100vh;
  background: linear-gradient(180deg, #0a0f1c 0%, #111827 100%);
  color: #ffffff;
  font-family: 'Inter', 'Segoe UI', sans-serif;
  padding-bottom: 4rem;
}

/* ===== Hero Section ===== */
.hero {
  text-align: center;
  margin-top: 4rem;
  margin-bottom: 3rem;
  animation: fadeIn 1.2s ease-in-out;
}

.hero h1 {
  font-size: 2.4rem;
  font-weight: 700;
  color: #00aeef;
  letter-spacing: 0.5px;
  margin-bottom: 0.5rem;
}

.hero .subtitle {
  font-size: 1.1rem;
  color: #cfd8dc;
}

/* ===== Grid Section ===== */
.grid-section {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2rem;
  width: 90%;
  max-width: 1000px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 2.5rem;
  box-shadow: 0 0 25px rgba(0, 174, 239, 0.25);
  backdrop-filter: blur(6px);
  animation: slideUp 1.2s ease-in-out;
}

/* ===== Card Styling ===== */
.card {
  background: #1e1e1e;
  color: #fff;
  width: 260px;
  padding: 1.5rem;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 174, 239, 0.3);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  text-align: center;
}

.card:hover {
  transform: translateY(-6px);
  box-shadow: 0 0 30px rgba(0, 174, 239, 0.6);
}

.card h2 {
  font-size: 1.4rem;
  color: #00aeef;
  margin-bottom: 0.5rem;
}

.card p {
  font-size: 0.95rem;
  color: #cfd8dc;
  margin-bottom: 1rem;
}

.card-link {
  display: inline-block;
  background: #00aeef;
  color: #fff;
  text-decoration: none;
  padding: 0.6rem 1.2rem;
  border-radius: 6px;
  font-weight: 600;
  transition: background 0.3s ease;
}

.card-link:hover {
  background: #0078d4;
}

/* ===== Footer ===== */
.footer {
  text-align: center;
  margin-top: 3rem;
  font-size: 0.9rem;
  color: #b0bec5;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 1.5rem;
}

/* ===== Animations ===== */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ===== Responsive ===== */
@media (max-width: 768px) {
  .hero h1 {
    font-size: 1.8rem;
  }

  .grid-section {
    padding: 1.5rem;
  }

  .card {
    width: 90%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/IndexPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,6DAA6D;EAC7D,cAAc;EACd,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,4CAA4C;EAC5C,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,2CAA2C;EAC3C,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".index-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  min-height: 100vh;\n  background: linear-gradient(180deg, #0a0f1c 0%, #111827 100%);\n  color: #ffffff;\n  font-family: 'Inter', 'Segoe UI', sans-serif;\n  padding-bottom: 4rem;\n}\n\n/* ===== Hero Section ===== */\n.hero {\n  text-align: center;\n  margin-top: 4rem;\n  margin-bottom: 3rem;\n  animation: fadeIn 1.2s ease-in-out;\n}\n\n.hero h1 {\n  font-size: 2.4rem;\n  font-weight: 700;\n  color: #00aeef;\n  letter-spacing: 0.5px;\n  margin-bottom: 0.5rem;\n}\n\n.hero .subtitle {\n  font-size: 1.1rem;\n  color: #cfd8dc;\n}\n\n/* ===== Grid Section ===== */\n.grid-section {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 2rem;\n  width: 90%;\n  max-width: 1000px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  padding: 2.5rem;\n  box-shadow: 0 0 25px rgba(0, 174, 239, 0.25);\n  backdrop-filter: blur(6px);\n  animation: slideUp 1.2s ease-in-out;\n}\n\n/* ===== Card Styling ===== */\n.card {\n  background: #1e1e1e;\n  color: #fff;\n  width: 260px;\n  padding: 1.5rem;\n  border-radius: 10px;\n  box-shadow: 0 0 20px rgba(0, 174, 239, 0.3);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  text-align: center;\n}\n\n.card:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 0 30px rgba(0, 174, 239, 0.6);\n}\n\n.card h2 {\n  font-size: 1.4rem;\n  color: #00aeef;\n  margin-bottom: 0.5rem;\n}\n\n.card p {\n  font-size: 0.95rem;\n  color: #cfd8dc;\n  margin-bottom: 1rem;\n}\n\n.card-link {\n  display: inline-block;\n  background: #00aeef;\n  color: #fff;\n  text-decoration: none;\n  padding: 0.6rem 1.2rem;\n  border-radius: 6px;\n  font-weight: 600;\n  transition: background 0.3s ease;\n}\n\n.card-link:hover {\n  background: #0078d4;\n}\n\n/* ===== Footer ===== */\n.footer {\n  text-align: center;\n  margin-top: 3rem;\n  font-size: 0.9rem;\n  color: #b0bec5;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  padding-top: 1.5rem;\n}\n\n/* ===== Animations ===== */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ===== Responsive ===== */\n@media (max-width: 768px) {\n  .hero h1 {\n    font-size: 1.8rem;\n  }\n\n  .grid-section {\n    padding: 1.5rem;\n  }\n\n  .card {\n    width: 90%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
